import React from "react";
import DOMPurify from "dompurify";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { LandTourDetail } from "../../../../interfaces/land-tour.interface";

interface Props {
  landTour: LandTourDetail;
}

export default function AboutTheTour({ landTour }: Props) {
  if (!landTour.description && !landTour.termsAndConditions) return null;

  return (
    <section className="ground-tour-show-v2__about">
      <h2 className="ground-tour-show-v2__section-title">About the Tour</h2>

      <div className="ground-tour-show-v2__about-blocks">
        {landTour.description && (
          <div className="ground-tour-show-v2__about-block">
            <h3>Descriptions</h3>
            <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{DOMPurify.sanitize(landTour.description)}</Markdown>
          </div>
        )}

        {landTour.termsAndConditions && (
          <div className="ground-tour-show-v2__about-block">
            <h3>Remarks</h3>
            <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeRaw]}>{DOMPurify.sanitize(landTour.termsAndConditions)}</Markdown>
          </div>
        )}
      </div>
    </section>
  );
}
